import { render, staticRenderFns } from "./TabConfigBasic.vue?vue&type=template&id=0575b416"
import script from "./TabConfigBasic.vue?vue&type=script&lang=js"
export * from "./TabConfigBasic.vue?vue&type=script&lang=js"
import style0 from "./TabConfigBasic.vue?vue&type=style&index=0&id=0575b416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports